/* ============================= */
/* VERSION V1.1 - SECTION RÉSERVATION */
/* ============================= */

import React, { useState } from "react";
import "../styles/Reservation.css";
import bgReservation from "../assets/background/taxi-belfort-toyota-1920.webp";

const Reservation = () => {
  const [status, setStatus] = useState("idle"); // idle | sending | ok | err

  const todayISO = new Date().toISOString().slice(0, 10);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status === "sending") return;

    const form = e.currentTarget;
    const formData = new FormData(form);

    // Honeypot anti-spam (si rempli -> on ignore)
    const honey = (formData.get("_honey") || "").toString().trim();
    if (honey) return;

    setStatus("sending");

    try {
      // Email plus lisible
      formData.append("_template", "table");

      const res = await fetch(
        "https://formsubmit.co/ajax/de73a42aee27cb93f7719de816c4ed29",
        {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        }
      );

      if (!res.ok) throw new Error("FormSubmit failed");

      setStatus("ok");
      form.reset();
    } catch (err) {
      console.error("Reservation form error:", err);
      setStatus("err");
    }
  };

  return (
    <section
      id="reservation"
      className="reservation-section"
      style={{ backgroundImage: `url(${bgReservation})` }}
      aria-labelledby="reservation-title"
    >
      <div className="reservation-container">
        <header className="reservation-header">
          <h2 className="reservation-title" id="reservation-title">
            Pré-réservation
          </h2>
          <p className="reservation-subtitle">
            Envoyez votre demande (gare, aéroport, longue distance). Confirmation rapide.
          </p>

          {/* SEO discret */}
          <span className="sr-only">
            Pré-réservation taxi Belfort : gare de Belfort, aéroport Bâle-Mulhouse, longue distance.
            Contact téléphone ou WhatsApp.
          </span>
        </header>

        <form className="reservation-form" onSubmit={handleSubmit}>
          {/* FormSubmit options */}
          <input type="hidden" name="_subject" value="Pré-réservation - Taxi de la Douce" />
          <input type="hidden" name="_captcha" value="false" />
          <input
            type="text"
            name="_honey"
            className="reservation-honeypot"
            tabIndex="-1"
            autoComplete="off"
            aria-hidden="true"
          />

          <div className="reservation-grid">
            <div className="reservation-field">
              <label htmlFor="r-nom">Nom</label>
              <input
                id="r-nom"
                type="text"
                name="nom"
                placeholder="Votre nom"
                autoComplete="name"
                required
              />
            </div>

            <div className="reservation-field">
              <label htmlFor="r-telephone">Téléphone</label>
              <input
                id="r-telephone"
                type="tel"
                name="telephone"
                placeholder="Ex : 07 49 42 49 19"
                inputMode="tel"
                autoComplete="tel"
                required
              />
            </div>

            <div className="reservation-field">
              <label htmlFor="r-email">Email (optionnel)</label>
              <input
                id="r-email"
                type="email"
                name="email"
                placeholder="Votre email"
                autoComplete="email"
              />
            </div>

            <div className="reservation-field">
              <label htmlFor="r-passagers">Passagers (optionnel)</label>
              <input
                id="r-passagers"
                type="number"
                name="passagers"
                min="1"
                max="8"
                placeholder="Ex : 2"
              />
            </div>

            <div className="reservation-field">
              <label htmlFor="r-depart">Adresse de départ</label>
              <input
                id="r-depart"
                type="text"
                name="depart"
                placeholder="Ex : Gare de Belfort"
                required
              />
            </div>

            <div className="reservation-field">
              <label htmlFor="r-arrivee">Adresse d’arrivée</label>
              <input
                id="r-arrivee"
                type="text"
                name="arrivee"
                placeholder="Ex : Aéroport Bâle-Mulhouse"
                required
              />
            </div>

            <div className="reservation-field">
              <label htmlFor="r-date">Date</label>
              <input id="r-date" type="date" name="date" min={todayISO} required />
            </div>

            <div className="reservation-field">
              <label htmlFor="r-heure">Heure</label>
              <input id="r-heure" type="time" name="heure" required />
            </div>

            <div className="reservation-field">
              <label htmlFor="r-type">Type</label>
              <select id="r-type" name="type" defaultValue="Aller simple">
                <option>Aller simple</option>
                <option>Aller / Retour</option>
                <option>Mise à disposition</option>
              </select>
            </div>

            <div className="reservation-field">
              <label htmlFor="r-bagages">Bagages (optionnel)</label>
              <input id="r-bagages" type="text" name="bagages" placeholder="Ex : 2 valises" />
            </div>
          </div>

          <div className="reservation-field">
            <label htmlFor="r-message">Infos complémentaires (optionnel)</label>
            <textarea
              id="r-message"
              name="message"
              rows="5"
              placeholder="Arrêt, attente, siège enfant, code porte, etc."
            />
          </div>

          <button className="reservation-btn" type="submit" disabled={status === "sending"}>
            {status === "sending" ? "Envoi..." : "Envoyer la pré-réservation"}
          </button>

          <div aria-live="polite">
            {status === "ok" && (
              <p className="reservation-feedback success">
                ✅ Demande envoyée. Je vous confirme rapidement.
              </p>
            )}

            {status === "err" && (
              <p className="reservation-feedback error">
                ❌ L’envoi a échoué. Réessayez ou contactez-moi directement.
              </p>
            )}
          </div>

          <div className="reservation-actions">
            <a
              href="https://wa.me/33749424919"
              className="reservation-whatsapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              💬 WhatsApp
            </a>
            <a className="reservation-phone" href="tel:+33749424919">
              📞 Appeler
            </a>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Reservation;
